module.exports = __webpack_public_path__ + "index_pc/img/icon_wechat.536d2e03.png";